<template>
  <div class="box">
    <header>
      <div class="left">
        <a-dropdown>
          <img :src="require(`@/assets/gentlemen.jpg`)" width="60" height="60" alt="" @click="e => e.preventDefault()">
          <a-menu slot="overlay">
            <a-menu-item @click="handleLogout">
              <a-icon type="logout"/>
              <span>退出登录</span>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <div class="top">
          <div class="name">
            <strong>{{ this.userInfo().realname }}</strong>
            <!-- <span>教授</span> -->
          </div>
          <!-- <div class="position">骨科 | 主治医生</div> -->
        </div>
      </div>
      <div class="right" v-if="menus.length === 2">
        <a-button @click="handleCreate">
          <a-icon type="plus"/>
          配置方案
        </a-button>
      </div>
    </header>
    <div style="padding: 15px;">
      <div class="list" v-if="projectList.length!==0">
        <project-card v-for="(item,index) in projectList" :key="index" :data="item" @clickGo="goProjectTemplate2" @titleClick="handleSelect(item)" ></project-card>
      </div>
      <a-empty v-else  class="no-data">
        <span slot="description" style="color: white;">暂无数据</span>
      </a-empty>
    </div>
    <project-create-model ref="projectCreateModel" @submit="submitHandle" @deleteChange="loadData"></project-create-model>
  </div>
</template>

<script>
  import { mapActions, mapGetters,mapState } from 'vuex'
  import ProjectCard from '@views/apppad/projectTemplate/comp/ProjectCard.vue'
  import { deleteAction, getAction, postAction } from '@api/manage'
  import ProjectCreateModel from '@views/apppad/index/comp/ProjectCreateModel.vue'

  export default {
    name: 'ProjectIndex',
    components: { ProjectCreateModel, ProjectCard },
    data() {
      return {
        projectList: [],
        ipagination: {
          current: 1,
          pageSize: 6,
          pageSizeOptions: ['6', '9', '12'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0,
          menus: [],
        }

      }
    },
    computed: {
      ...mapState({
        // 后台菜单
        permissionMenuList: state => state.user.permissionList
      })
    },
    created() {
      this.menus = this.permissionMenuList.filter(item=>item.location === 1)
    },
    mounted() {
      this.loadData();
    },
    methods: {
      ...mapGetters(["userInfo"]),
      ...mapActions(["Logout"]),
      submitHandle(createId) {
        this.loadData()
        if (createId) {
          this.$confirm({
            title: '添加成功！',
            content: (<div>
              <p>添加成功！是否进行下一步配置？</p>
            </div>),
            centered: false,
            onOk: () => {
              this.goProjectTemplate(createId)
            }
          })
        }
      },
      loadData() {
        getAction('/projectconfigview/configProject/list').then(res => {
          if (res.success) {
            this.projectList = res.result.records || res.result
            if (res.result.total != null && res.result.total !== undefined) {
              this.ipagination.total = res.result.total
            }
          } else {
            this.$message.error('后台请求异常')
          }
        })
      },
      pageChange(pageNumber, pageSize) {
        this.ipagination.current = pageNumber
        this.ipagination.pageSize = pageSize
        this.loadData()
      },
      goProjectTemplate(id) {
        this.$router.push({
          path: '/pad/projectTemplate',
          query: {
            id,
            goIndex:1
          }
        })
      },
      goProjectTemplate2(id) {
        this.$router.push({
          path: '/pad/proposalConfig',
          // query: {
          //   id: id
          // }
        })
      },
      handleSelect(record) {
        this.$refs.projectCreateModel.edit(record)
      },
      handleCreate(){
        postAction('/projectconfigview/configProject/limitCount').then(res=>{
          if(res.success){
            this.$refs.projectCreateModel.add()
          }else{
            this.$message.error(res.message)
          }
        })
      },
      handleLogout() {
        const that = this
        this.$confirm({
          title: '提示',
          content: '真的要注销登录吗 ?',
          onOk() {
            return that.Logout({}).then(() => {
              // update-begin author:wangshuai date:20200601 for: 退出登录跳转登录页面
              // that.$router.push({ path: '/pad' });
              that.$router.push({ path: '/user/login',query:{
                  redirect:'/pad'
                } });
              // update-end author:wangshuai date:20200601 for: 退出登录跳转登录页面
              //window.location.reload()
            }).catch(err => {
              that.$message.error({
                title: '错误',
                description: err.message
              })
            })
          },
          onCancel() {
          },
        });
      },
    }
  }
</script>

<style scoped lang="less">
  .box{
    min-height: 100vh;
    background: url(~@/assets/bg01.png) center top no-repeat;
    background-size: cover;

    header{
      height: 100px;
      padding: 0 20px;
      border-bottom: 1px solid rgb(71, 71, 71);
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left{
        display: flex;
        gap: 20px;
        align-items: center;
        img{
          border-radius: 50%;
        }
      }
      .name{
        display: flex;
        align-items: center;
        justify-content: space-between;
          color: white;
          strong{
            font-size: 16px;
          }
          span{
            display: inline-block;
            width: 34px;
            height: 20px;
            border-radius: 42px;
            background: rgba(55, 110, 255, 1);
            font-size: 11px;
            text-align: center;
            line-height: 20px;
          }
      }
      .position{
        font-size: 13px;
        color: rgba(110, 117, 132, 1);
        margin-top: 5px;
      }
      .right{
        button{
          width: 120px;
          height: 48px;
          font-size: 16px;
          color: white;
          background-color: rgba(55, 110, 255, 1);
          border-color: rgba(55, 110, 255, 1);
          border-radius: 38px;
        }
      }
    }

    .no-data{
      position: absolute;
      left: 50%;
      top:50%;
      transform: translate(-50%,-50%);
    }
  }

  .list{
    display: grid;
    grid-template-columns: repeat(auto-fill, 320px);
    justify-content: center;
    gap: 20px 16px;
  }
  .list::after {
    content: "";
    flex: auto;
  }
</style>
